import {VisitorSurveyQuestion} from './VisitorSurveyQuestion';

export class VisitorSurvey {
  public questions: Array<VisitorSurveyQuestion> = [];

  constructor(data: any) {
    if (data && Array.isArray(data) && data.length > 0) {
      this.questions = data.map(vsq => new VisitorSurveyQuestion(vsq));
    } else {
      throw new Error('VisitorSurvey: Error: Tried to initialized a VisitorSurvey without any data.');
    }
  }
}
